import Dropdown from "@/components/Dropdown/Dropdown"
import { TDropdownItemData } from "@/components/Dropdown/types"
import ChevronDownDropdown from "@/components/Icon/ChevronDownDropdown"
import { Divider } from "@/components/LanguageSelect/styles"
import { languageItems } from "@/constants/language"
import { NAV_MENU } from "@/constants/navMenu"
import { useActiveNavLink } from "@/hooks/useActiveNavLink"
import { rem } from "@/styles/utils"
import { gray, primary } from "@/styles/variable"
import clsx from "clsx"
import { useTranslation } from "react-i18next"
import { Link, useLocation } from "react-router-dom"
import { useGaAttribute } from "../hooks"
import { DesktopMenuRoot, LanguageItem, LinkContainer } from "./styles"

export const DESKTOP_OFFSET_TOP = -122 // This value should be equal to the header height

export const DesktopMenu = () => {
  const { pathname } = useLocation()

  const { activeId, scrollToElement } = useActiveNavLink(
    NAV_MENU.map((item, index) => ({ ...item, id: index })),
    DESKTOP_OFFSET_TOP
  )

  const {
    t,
    i18n: { language, changeLanguage }
  } = useTranslation()
  const { setGaAttribute } = useGaAttribute()

  const selectedLanguage = languageItems.find(item => item.value === language)
  const languageOptions: TDropdownItemData[] = [
    ...(selectedLanguage
      ? [
          {
            ...selectedLanguage,
            render: () => (
              <LanguageItem>
                {selectedLanguage.label}
                <span className="icon">
                  <ChevronDownDropdown />
                </span>
              </LanguageItem>
            )
          }
        ]
      : []),
    ...languageItems.filter(item => item.value !== language)
  ]

  const handleLanguageChange = (lng: string) => {
    changeLanguage(lng)
    sessionStorage.setItem("i18nextLng", lng)
  }

  const handleNavigate = (url: string) => {
    if (pathname === url) {
      window.scrollTo(0, 0)
    }
    const isHashLink = url.includes("#")
    if (isHashLink) scrollToElement(url.split("#")[1])
  }

  return (
    <DesktopMenuRoot>
      <LinkContainer>
        {NAV_MENU.map((item, index) => {
          return (
            <Link
              key={index}
              to={item.url}
              onClick={() => handleNavigate(item.url)}
              className={clsx("link", {
                active: pathname === item.url || activeId === index
              })}
              {...setGaAttribute(t(item.title))}
            >
              {t(item.title)}
            </Link>
          )
        })}
      </LinkContainer>
      <Divider />
      <div
        data-action
        data-event="maingnb_setting"
        data-value="gnb_setting"
        data-label="GNB -언어 세팅 클릭 수"
      >
        <Dropdown
          menuPosition="bottom"
          items={languageOptions}
          label={selectedLanguage?.label ?? ""}
          onSelect={e => handleLanguageChange(e.value)}
          menuStyles={{
            top: "-12px",
            left: "-18px",
            border: "unset",
            padding: `12px 18px`,
            borderRadius: "18px",
            alignItems: "flex-start",
            gap: rem(7),
            color: gray.FF60,
            backgroundColor: primary.black,
            fontSize: "18px",
            fontWeight: "600",
            lineHeight: "160%",
            letterSpacing: "-0.9px",
            transform: "translate(0, 0)",
            cursor: "pointer",
            userSelect: "none"
          }}
          triggerStyles={{
            border: "none",
            padding: 0,
            gap: "8px",
            backgroundColor: "transparent",
            fontSize: "18px",
            fontWeight: "600",
            lineHeight: "160%",
            letterSpacing: "-0.9px",
            opacity: 0.7
          }}
          arrowStyles={{
            transition: "none"
          }}
        />
      </div>
    </DesktopMenuRoot>
  )
}
